import { Link, useNavigate } from 'react-router-dom';
import {useState} from "react";

const tabs = [
    { name: 'Einstellungen', href: '/company', current: false },
    { name: 'Benutzer', href: '/company/users', current: false },
    { name: 'Lizenzen', href: '/company/license', current: false },
    { name: 'Integrationen', href: '/company/integrations', current: true },
]

export default function CompanyTabs(data) {

    const [value, setValue] = useState(null);
    const navigate = useNavigate();

    for(var a = 0; a < tabs.length ; a++) {
        if(data?.page === tabs?.[a]?.name) {
            tabs[a].current = true;
        } else {
            tabs[a].current = false;
        }
    }


    const handleChange = (event) => {
        const path = event.target.value;
        if (path) {
            navigate(path);
        }
    };


    return (
        <div className={"mb-10"}>
            <div className="grid grid-cols-1 sm:hidden">
                {/* Use an "onChange" listener to redirect the user to the selected tab URL. */}
                <select
                    defaultValue={tabs.find((tab) => tab.current)?.name || ''}
                    onChange={handleChange}
                    aria-label="Select a tab"
                    className="col-start-1 row-start-1 w-full appearance-none rounded-md bg-white py-2 pl-3 pr-8 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600"
                >
                    {tabs.map((tab) => (
                        <option value={tab.href}>{tab.name}</option>
                    ))}
                </select>
            </div>
            <div className="hidden sm:block">
                <div className="border-b border-gray-400">
                    <nav aria-label="Tabs" className="-mb-px flex space-x-8">
                        {tabs.map((tab) => (
                            <Link
                                key={tab.name}
                                to={tab.href}
                                aria-current={tab.current ? 'page' : undefined}
                                className={`${tab.current
                                        ? 'border-gray-900 text-gray-900'
                                        : 'border-transparent text-gray-600/60 hover:border-gray-400 hover:text-gray-900'}
                                    whitespace-nowrap border-b-2 px-1 py-4 text-sm font-medium`}
                            >{tab.name}</Link>
                        ))}
                    </nav>
                </div>
            </div>
        </div>
    )
}
